module.exports = __webpack_public_path__ + "static/media/angle-down.80baf34f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/angle-down.svg
// module id = 965
// module chunks = 3